import React, { useState, memo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Axios from "axios";
import "../styles/compo.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../images/logo.png";
import swal from "sweetalert";
import Cookie from "universal-cookie";
import ParticlesBackground from "./ParticlesBackground";
import config from "../config.js";
import { encrypt } from "./useCryptoJS";

// Memoize ParticlesBackground to prevent re-renders unless props change
const MemoizedParticlesBackground = memo(ParticlesBackground);

const Login = () => {
  const cookies = new Cookie();
  const [loggedIn, setLoggedIn] = useState(!!cookies.get("userID"));
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  if (loggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  const formSubmit = async (ev) => {
    ev.preventDefault();

    if (!username.trim() || !password.trim()) {
      swal("Login failed!", "Username and password cannot be empty.", "error");
      return;
    }

    const cookieOptions = {
      path: "/",
      secure: false, // Set to true if using HTTPS
      maxAge: 86400,
    };

    try {
      if (username === "superuser") {
        const res = await Axios.post(config.BACKEND_URL + "/superuser/login", {
          username,
          password,
        });
        if (res.status === 200) {
          cookies.set("userID", res.data.id.toString(), cookieOptions);
          cookies.set("userToken", res.data.userToken, cookieOptions);
          cookies.set("userStatus", encrypt("superuser"), cookieOptions);
          [
            "urname",
            "uruser",
            "uruserGroup",
            "uruserDashboard",
            "uralarm",
            "urview",
            "ursource",
            "urdashboard",
          ].forEach((key) => cookies.set(key, encrypt("1111"), cookieOptions));
          cookies.set("urrole", encrypt("11111"), cookieOptions);
          cookies.set("urreport", encrypt("1"), cookieOptions);
          setLoggedIn(true);
          //swal("Super User Login Successfully", "Click on OK to continue...", "success");
          navigate("/dashboard", { replace: true });
        } else {
          swal("Login failed!", "Invalid Username or Password", "error");
        }
      } else {
        const res = await Axios.post(config.BACKEND_URL + "/users/login", {
          username,
          password,
        });
        if (res.data.isEmailAuthenticated === false) {
          swal(
            "Login failed!",
            "Please check mail and verify your email address",
            "error"
          );
          await Axios.post(config.BACKEND_URL + "/users/login-authenticate", {
            loginUser: true,
            username,
          }).catch((err) =>
            console.error("Authentication request failed:", err)
          );
          setLoggedIn(false);
        } else if (res.status === 200) {
          cookies.set("userID", res.data.id.toString(), cookieOptions);
          cookies.set("userToken", res.data.userToken, cookieOptions);
          cookies.set(
            "urname",
            encrypt(res.data.roleOfUser.name),
            cookieOptions
          );
          cookies.set(
            "uruser",
            encrypt(res.data.roleOfUser.user),
            cookieOptions
          );
          cookies.set(
            "uruserGroup",
            encrypt(res.data.roleOfUser.userGroup),
            cookieOptions
          );
          cookies.set(
            "uruserDashboard",
            encrypt(res.data.roleOfUser.userDashboard),
            cookieOptions
          );
          cookies.set(
            "uralarm",
            encrypt(res.data.roleOfUser.alarm),
            cookieOptions
          );
          cookies.set(
            "urview",
            encrypt(res.data.roleOfUser.view),
            cookieOptions
          );
          cookies.set(
            "ursource",
            encrypt(res.data.roleOfUser.source),
            cookieOptions
          );
          cookies.set(
            "urrole",
            encrypt(res.data.roleOfUser.role),
            cookieOptions
          );
          cookies.set(
            "urdashboard",
            encrypt(res.data.roleOfUser.dashboard),
            cookieOptions
          );
          cookies.set(
            "urreport",
            encrypt(res.data.roleOfUser.report),
            cookieOptions
          );
          setLoggedIn(true);
          swal("Login successful!", "Click on OK to continue...", "success");
          // navigate("/dashboard", { replace: true });
          setTimeout(() => {
            navigate("/dashboard", { replace: true });
          }, 150);
        } else {
          swal(
            "Login failed!",
            "Invalid credentials or Role is not assigned to the user",
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Login error:", err.message);
      swal("Login failed!", "Invalid credentials or server error", "error");
    }
  };

  return (
    <div className="container">
      <MemoizedParticlesBackground />
      <div className="formDiv">
        <form className="form" onSubmit={formSubmit}>
          <h4>
            <img
              src={logo}
              alt="Embedos Logo"
              className="mx-2"
              style={{ width: "32px", height: "32px" }}
            />
            <strong>Embedos Dashboard 3.0</strong>
          </h4>
          <br />
          <h4>
            <strong>Login</strong>
          </h4>
          <br />
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: "40%" }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
